import * as React from 'react';
import { useCallback } from 'react';

import { useNavigation } from 'hooks/navigation/use-navigation';

import { ITermsProps } from './types';

const useTerms = ({
  onShowTermsModal,
  termsButtonText,
  termsButtonUrl,
  termsText,
}: ITermsProps) => {
  const { navigate } = useNavigation();

  const onClickTermsLink = useCallback(
    // TODO: RN - Fix type on this function once all consumers are migrated
    (e?: React.MouseEvent<HTMLAnchorElement>) => {
      // If there is termsText then this is a modal
      if (termsText) {
        onShowTermsModal({
          heading: termsButtonText,
          content: termsText,
        });
      }
      // Otherwise navigate to the url
      if (termsButtonUrl) {
        navigate(termsButtonUrl);
        e?.preventDefault();
      }
    },
    [termsText, navigate, onShowTermsModal, termsButtonText, termsButtonUrl]
  );
  return onClickTermsLink;
};

export default useTerms;
